var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 49,
    viewBox: "0 0 161 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7358 6.29499L40.2377 11.1212H32.7466L34.2448 6.29499H41.7358ZM29.5362 22.662L31.2484 16.5768H39.3815C43.6621 16.5768 46.2305 14.6883 47.5146 10.7015L48.1567 8.39334C49.655 3.35735 47.3007 0 41.7358 0H6.63494L0 22.4522H29.5362V22.662Z",
    fill: "#F2F740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.57 6.29516H63.3524V13.4294H56.5032L60.57 6.29516ZM51.1525 22.6621L53.2927 18.8851H63.3524V22.6621H69.9868V0.209961H57.145L43.6614 22.6621H51.1525Z",
    fill: "#F2F740"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4703 6.29516H90.7479L89.4635 11.1213H81.9723L83.4703 6.29516ZM96.7404 10.7017L97.3823 8.6033C98.881 3.35746 96.5263 0.209961 90.9614 0.209961H78.548L71.913 22.6621H78.7622L80.4744 16.577H84.7547L86.6811 22.6621H93.7438L91.604 16.1573C94.1722 15.318 95.8844 13.6393 96.7404 10.7017Z",
    fill: "#F2F740"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.163 22.6621L109.797 0.209961H102.949L96.3137 22.6621H103.163Z",
    fill: "#F2F740"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.357 25.8096L52.4376 34.8324L49.4412 25.8096H19.691L13.2701 48.2618H42.8063L46.4448 35.8816L48.7991 42.8061H53.0797L59.5009 35.4619L55.8618 48.2618H62.711L69.1319 25.8096H60.357Z",
    fill: "#F2F740"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6926 39.0291L81.7595 31.8948H84.5419V39.0291H77.6926ZM78.3352 25.8096L64.8508 48.2618H72.5562L74.6967 44.4847H84.7561V48.2618H91.3905V25.8096H78.3352Z",
    fill: "#F2F740"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.505 32.3144L116.217 25.8096H95.4569L93.5305 32.3144H101.022L96.5271 48.2618H103.376L107.87 32.3144H114.505Z",
    fill: "#F2F740"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.496 32.3144H133.983L135.91 25.8096H124.78C120.5 25.8096 117.931 27.6981 116.647 31.6849L114.292 39.8685C112.794 45.1142 115.148 48.2618 120.713 48.2618H129.275L131.201 41.757H120.713L123.496 32.3144Z",
    fill: "#F2F740"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.46 25.8096L151.105 33.9931H143.401L145.755 25.8096H138.906L132.271 48.2618H139.12L141.474 40.2881H149.393L147.039 48.2618H153.888L160.309 25.8096H153.46Z",
    fill: "#F2F740"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a92cac71412192687df17ef9bc862628.svg";
export { ForwardRef as ReactComponent };